import * as THREE from 'three';
import { Renderer } from './Renderer';
import { Camera } from './Camera';
import { Scene } from './Scene';
import { Env } from './Env';

export class EventHandling{

    static dragEvent = false;

    constructor(){

        if (Env.data.mousemoveListener) {
            Env.inputElement.addEventListener('mousemove', function () {
                if (Renderer.animate) {
                    Renderer.animate.setRendererFlag(120);
                }
            })
        }


        Env.inputElement.addEventListener('pointerup', function (e: any) {
            if (!EventHandling.dragEvent && e.button === 0) {
                try {
                    const rect = Env.inputElement.getBoundingClientRect();
                    const _pointer = new THREE.Vector2(
                        ((e.clientX - rect.left) / rect.width * 2 - 1),
                        (- (e.clientY - rect.top) / rect.height * 2 + 1)
                    );
                    const _raycaster = new THREE.Raycaster();
                    _raycaster.setFromCamera(_pointer, Camera.camera);
                    const intersect = _raycaster.intersectObjects(Scene.scene.children);
                    let index;
                    for (const i in intersect) {
                        if (!intersect[i].object.name.includes('wall')) {
                            index = parseInt(i);
                            break;
                        }
                    }
                    const intersected = getParent(intersect[index].object);
                    dispatchEvent(
                        new CustomEvent(
                            intersected.uuid,
                            { detail: { event: 'click', intersected: intersected } }
                        )
                    )
                    function getParent(node) {
                        if (node.parent.parent.name === 'cabinets') {
                            return node;
                        } else {
                            return getParent(node.parent);
                        }
                    }
                } catch (e) {
                }
            }
        });
    }
}